import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kHTMLCore } from "../../../Admin/kReusableCoreTS/kHTMLCore";

// AppSkeleton - LOADING PLACEHOLDERS (owner-approved design item 11a, 2026-09-30: "Yes, a loading placeholder"). Grey shapes
// where the content will stand - chat rows while `index.json` loads, bubbles while a chat opens - with a soft shimmer that
// stops for `prefers-reduced-motion` (app.css). They replace blank space and "Loading…" lines.
// ⚠ A SCREEN READER STILL HEARS WHAT IS HAPPENING: the region carries `aria-busy="true"` and a visually hidden `.sr` status
// that says it in words ("Opening your archive…"), first in the region's text - the harnesses (`owner.mjs`,
// `real-archive.e2e.mjs`) read that same sentence to know the page is still loading.
// ⛔ No inline style (the CSP): widths are classes (`w1`..`w4`), never `style=`.

export class AppSkeleton {
    public static readonly BusyClass: string = "skelwrap";

    /** Chat rows (the list view's shape) while the chat list loads. */
    public static List = (Rows: number, Say: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Out: string[] = ["<div class=\"" + AppSkeleton.BusyClass + " skellist\" aria-busy=\"true\">"
                + AppSkeleton.Status(Say) + "<ul class=\"skelrows\" aria-hidden=\"true\">"];
            for (let At: number = 0; At < Rows; At = At + 1) {
                Out.push("<li class=\"skelrow\"><span class=\"skel skeldisc\"></span><span class=\"skellines\">"
                    + "<span class=\"skel skelline w" + String(1 + (At % 3)) + "\"></span>"
                    + "<span class=\"skel skelline short w" + String(1 + ((At + 1) % 4)) + "\"></span></span></li>");
            }
            Out.push("</ul></div>");
            return Out.join("");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSkeleton.List");
            return "";
        }
    };

    /** Chat bubbles, alternating sides, while a chat's page is read and drawn. */
    public static Chat = (Say: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Out: string[] = ["<div class=\"" + AppSkeleton.BusyClass + " skelchat\" aria-busy=\"true\">" + AppSkeleton.Status(Say)
                + "<div class=\"skelbubbles\" aria-hidden=\"true\">"];
            for (let At: number = 0; At < 7; At = At + 1) {
                let Side: string = "them";
                if (At % 3 === 1) { Side = "me"; }
                Out.push("<span class=\"skel skelbubble " + Side + " w" + String(1 + (At % 4)) + "\"></span>");
            }
            Out.push("</div></div>");
            return Out.join("");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSkeleton.Chat");
            return "";
        }
    };

    /** The words for a screen reader (and the harnesses), visually hidden. */
    public static Status = (Say: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return "<p class=\"sr\" role=\"status\">" + kHTMLCore.EscapeHtml(Say) + "</p>";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSkeleton.Status");
            return "";
        }
    };
}
